import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';  // Ensure you're importing from 'react-dom/client'
import { Amplify } from 'aws-amplify';
import App from './App.tsx';

// amplify_outputs.json is auto-generated by `npx ampx sandbox` (dev) or by the
// Amplify Hosting CI build (production), then copied into src/ by the
// prestart/prebuild hook (scripts/sync-amplify-outputs.js). CRA cannot import
// it from the repo root, so it must be read from inside src/.
import outputs from './amplify_outputs.json';

if (outputs && Object.keys(outputs).length > 0) {
  Amplify.configure(outputs);
} else {
  console.warn(
    '[Amplify] amplify_outputs.json is empty. Run `npx ampx sandbox` to generate it — /admin will not work until you do.'
  );
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);